// Routing hint only: the portal still restores and verifies its own credentials.
const key = (hostname) => `profiteia_portal_session_${hostname.replaceAll('.', '_')}`;

export function writePortalSessionHint(authenticated) {
  const host = window.location.hostname;
  if (host !== 'localhost' && !host.endsWith('.profiteia.io')) return;
  const domain = host.endsWith('.acc.profiteia.io') ? '; Domain=acc.profiteia.io'
    : host.endsWith('.profiteia.io') ? '; Domain=profiteia.io' : '';
  document.cookie = `${key(host)}=${authenticated ? '1' : ''}; Path=/; SameSite=Lax; Max-Age=${authenticated ? 31536000 : 0}${domain}${window.location.protocol === 'https:' ? '; Secure' : ''}`;
}

export function portalNewsRedirect(route, portalOrigin, cookie = document.cookie) {
  if (!['public-news', 'public-news-article'].includes(route.name)) return null;
  const origin = new URL(portalOrigin);
  if (!cookie.split(';').some((part) => part.trim() === `${key(origin.hostname)}=1`)) return null;
  const slug = route.name === 'public-news-article' ? `/${encodeURIComponent(route.params.slug)}` : '';
  const query = new URLSearchParams(route.query || {}).toString();
  // Public portal entry lets an expired session fall back to anonymous reading.
  return `${origin.origin}/#/public/nieuws${slug}${query ? `?${query}` : ''}${route.hash || ''}`;
}
